// Animated page backgrounds, powered by Vanta.js (https://www.vantajs.com).
//
// Each entry picks a Vanta `effect` and the options for it. The easiest way to
// design one is the configurator on vantajs.com: choose an effect, tune the
// sliders, then copy the options it prints into `options` below.
//
// Available effects: birds, cells, clouds, clouds2, dots, fog, globe, halo,
// net, rings, ripple, topology, trunk, waves.
//
// `routes` maps a page path to an entry; anything unlisted uses `default`.
// Pages that share an entry don't re-animate when you move between them.

export const transitionMs = 1200;

const karrakin = {
	color: 0xb8973a,
	color2: 0x7a1c2e,
	backgroundColor: 0x1a1a1f,
};

export const backgrounds = {
	default: {
		effect: "globe",
		options: {
			...karrakin,
			size: 2.0,
			sphereRotation: -0.002,
			meshRotation: 0.004,
		},
	},
	// Calmer placeholder for the carousel pages (and the timeline) — swap in your own design.
	roster: {
		effect: "waves",
		options: {
			color: 0x2a1a22,
			shininess: 25.0,
			waveHeight: 12.0,
			waveSpeed: 0.45,
			zoom: 0.85,
		},
	},
};

export const routes = {
	"/pilots": "roster",
	"/chassis": "roster",
	"/timeline": "roster",
};
